import fname from '../config/data/fname.js';
import lname from '../config/data/lname.js';
import pictures from '../config/data/pictures.js';
import taskmaster from '../config/data/taskmaster.js';


var config = {};
config.version = '2.2.8';
config.env = 'production';

config.weather = {access_id: 'qbhZanXbxHBcFbPTkqlmq', secret_key: 'oLPSpImhGmAuXTCSSVQTK2blHk4BDkXZQoeS8CEE'};

config.api = 'http://supervisor.getsmartconnect.com/manager/api/';

config.mode = 'game';
config.auth = {
	'project': ['super manager'],
	'trace': ['super manager'],
	'assets': ['super manager', 'project manager'],
	'worker.name': ['super manager'],
	'worker.picture': ['super manager'],
	'profile-panel': ['super manager']

}

config.zone_types = {
    'parking': { label: 'Parking Lot', color: 'rgba(200,200,200,0.3)', movement: 'stand' },
    'work': { label: 'Work', color: 'rgba(191, 17, 17, 0.3)', movement: 'random' },
    'break': { label: 'Break', color: 'rgba(159, 11, 192, 0.3)', movement: 'stand' },
    'planning': { label: 'Planning', color: 'rgba(11, 135, 192, 0.3)', movement: 'grouped' },
    'muster': { label: 'Muster', color: 'rgba(44, 192, 11, 0.3)', movement: 'grouped' },
    'start': { label: 'Start Point', color: 'rgba(255,255,0,0.3)', movement: 'random' },
    'stairs': { label: 'Stairs', color: 'rgba(0,0,255,0.3)', movement: 'stand' },
	'restricted': { label: 'Restricted', color: 'rgba(255,0,0,0.3)', movement: 'random' },
	'travel': { label: 'Travel', color: 'rgba(200, 200, 200, 0.3)', movement: 'random' },
}

config.companies = [{
        id: 'regis-construction',
        title: 'Regis Construction',
        bg_color: '#3e547d',
        workers: {
            civil: 5
        }
    },
    {
        id: 'stepp-civil-engineers',
        title: 'Stepp Civil Engineers',
        bg_color: '#727394',
        workers: {
            civil: 5
        }
    },
    {
        id: 'strike-a-pose-safety',
        title: 'Strike A Pose Safety',
        bg_color: '#00fee9',
        workers: {
            safety: 5
        }
    },
    {
        id: 'dark-knight-electrical',
        title: 'Dark Knight Electrical',
        bg_color: 'yellow',
        workers: {
            electrical: 5
        }
    },
    {
        id: 'expenser-mechanics',
        title: 'Expenser Mechanics',
        bg_color: 'pink',
        workers: {
            mechanical: 5
        }
    }
]

config.worker_types = {
    'civil': { label: 'Civil', jobs: ["civil-equipment-operator", "carpenter", "iron-worker", 'laborer', 'painter', 'rigger', 'scaffold-builder'] },
    'electrical': { label: 'Electrical', jobs: ["eletrician", 'instrument-tech'] },
    'mechanical': { label: 'Mechanical', jobs: ['crane-operator', 'mill-wright', 'pipefitter', 'welder'] },
    'safety': { label: 'Safety', jobs: ["safety-support"] },
}

config.vehicle_types = {
	'bulldozer': {label: 'Bulldozer', img: 'bulldozer.svg', capacity: 1, speed: 8, color: 'rgba(207, 0, 15, 1)'},
	'dumptruck': {label: 'Dump Truck', img: 'dumptruck.svg', capacity: 1, speed: 15, color: 'rgba(244, 208, 63, 1)'},
	'excavator': {label: 'Excavator', img: 'excavator.svg', capacity: 1, speed: 8, color: 'rgba(248, 148, 6, 1)'},
	'forklift': {label: 'Forklift', img: 'forklift.svg', capacity: 1, speed: 8, color: 'rgba(248, 148, 6, 1)'},
	'front-loader': {label: 'Front Loader', img: 'front-loader.svg', capacity: 1, speed: 8, color: 'rgba(245, 171, 53, 1)'},
	'grader': {label: 'Grader', img: 'grader.svg', capacity: 1, speed: 8, color: 'rgba(150, 40, 27, 1)'},
	'transport': {label: 'Transport', img: 'dumptruck.svg', capacity: 6, speed: 15, color: 'rgba(103, 128, 159, 1)'},
}

config.job_types = {
    'carpenter': { label: 'Carpenter/Insulator', img: 'carpenter.svg', class: 'tools' },
    'civil-equipment-operator': { label: 'Civil Equip Operator', img: 'civil-equip-operator.svg', class: 'tools' },
    'crane-operator': { label: 'Crane Operator', img: 'crane-operator.svg', class: 'machines' },
    'eletrician': { label: 'Electrician', img: 'electrical-engineer.svg', class: 'tech' },
    'instrument-tech': { label: 'Instrument Tech', img: 'instrument-tech.svg', class: 'tech' },
    'iron-worker': { label: 'Iron Worker', img: 'iron-worker.svg', class: 'machines' },
    'laborer': { label: 'Laborer', img: 'laborer.svg', class: 'tools' },
    'mill-wright': { label: 'Mill Wright', img: 'mill-wright.svg', class: 'parts' },
    'painter': { label: 'Painter', img: 'painter.svg', class: 'safe' },
    'pipefitter': { label: 'Pipefitter', img: 'pipe-fitter.svg', class: 'parts' },
    'rigger': { label: 'Rigger', img: 'rigger.svg', class: 'machines' },
    'safety-support': { label: 'Safety Support', img: 'safety.svg', class: 'safe' },
    'scaffold-builder': { label: 'Scaffold Builder', img: 'scaffold-erector.svg', class: 'machines' },
    'welder': { label: 'Welder', img: 'welder.svg', class: 'tools' }
}

config.icon_class = {
    'tools': '#F7941E',
    'machines': '#BE1E2D',
    'tech': '#D7DF23',
    'parts': '#1C75BC',
    'safe': '#009444'
}


config.routines = {
    'civil': {
        '7:00': 'start',
        '7:30': 'planning',
        '8:00': 'work',
        '12:00': 'break',
        '13:00': 'work',
        '17:00': 'end'
            // '7:01': 'work',
            // '7:15': 'end'
    },
    'mechanical': {
        '7:00': 'start',
        '7:30': 'planning',
        '8:00': 'work',
        '12:00': 'break',
        '13:00': 'work',
        '17:00': 'end'
    },
    'safety': {
        '7:00': 'start',
        '7:30': 'planning',
        '8:00': 'work',
        '12:00': 'break',
        '13:00': 'work',
        '17:00': 'end'
    },
    'electrical': {
        '7:00': 'start',
        '7:30': 'planning',
        '8:00': 'work',
        '12:00': 'break',
        '13:00': 'work',
        '17:00': 'end'
    },
}

config.data = {};
config.data.fname = fname;
config.data.lname = lname;
config.data.pictures = pictures;
config.data.taskmaster = taskmaster;

config.start_time = {
    hour: '7',
    minute: '25'
}

config.end_time = {
    hour: '17',
    minute: '00'
}

config.first_starts = '9.5';

config.efficiency_levels = Array.from({ length: 10 }, (x, i) => i + 1);
config.safety_levels = Array.from({ length: 10 }, (x, i) => i + 1);

config.walking_speed = [4, 1.5];

config.report_colors = { 0: '#f92400', 50: '#f7c31b', 70: '#00a155' };

config.speed_options = [1, 32, 64, 128];

var env = require('./_config.'+TARGET_ENV+'.js');

config = {...config, ...env.default};

export default config;
